import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { Icon } from "../Icons/Svg";
import { Email } from "../../BaseComponents/Icons/Svg";

export const EmailLinkStyle = styled.a.attrs(({ email }) => ({
	href: `mailto:${email}`,
}))`
	margin: ${({ margin }) => (margin ? margin : "5px")};
	color: black !important;
	font-size: 15px;
	display: flex;
	align-items: center;
	width: fit-content;

	&:hover {
		span {
			border-color: transparent;
		}
	}
	span {
		border-bottom: 1px solid black;
		transition: 0.2s ease;
	}
	svg {
		width: 16px;
		height: 12px;
		margin-right: 5px;
	}
	#email-icon {
		stroke: ${({ theme }) => theme.colors.primary};
	}
`;

export const EmailLink = ({ email, margin, svg }) => {
	return (
		<EmailLinkStyle margin={margin} email={email}>
			{svg ? <Email /> : <Icon className="icon-mail"></Icon>}
			<span>{email} </span>
		</EmailLinkStyle>
	);
};
